import * as React from 'react';

import Button from 'components/atoms/v2/Button';

import classes from './FavoriteEmptyState.scss';

type Action = {
  label: string;
  handler: () => void;
};

type Props = {
  title?: string;
  description: string;
  action?: Action | null;
};

const FAVORITE_EMPTY_STATE_IMAGE_URL = 'https://images.tanp.jp/gracia.tanp/icons/login_modal_img.png';
const DEFAULT_TITLE = '追加された商品がありません';

const FavoriteEmptyState: React.FC<Props> = ({ title = DEFAULT_TITLE, description, action }) => (
  <div className={classes['empty-state']}>
    <img
      className={classes['empty-state__icon']}
      src={FAVORITE_EMPTY_STATE_IMAGE_URL}
      alt="favorite_gift_icon"
      decoding="async"
      loading="lazy"
    />
    <p className={classes['empty-state__title']}>{title}</p>
    <p className={classes['empty-state__description']}>{description}</p>
    {action ? (
      <Button
        variant="secondary"
        className={classes['empty-state__action']}
        onClick={action.handler}
        label={action.label}
      />
    ) : null}
  </div>
);

export default FavoriteEmptyState;
